export default {"src":"/_next/static/media/ra-arrow-down.2dd34aaf.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};